import script from "./EventCard.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./EventCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventCard.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./EventCard.vue?vue&type=script&lang=ts&setup=true"

import "./EventCard.vue.scss?vue&type=style&index=0&id=5d766a32&scoped=true&lang=scss!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./EventCard.vue?vue&type=style&index=0&id=5d766a32&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d766a32"]])

export default __exports__